import { render, staticRenderFns } from "./request-number.vue?vue&type=template&id=702ff83c&scoped=true&"
import script from "./request-number.vue?vue&type=script&lang=js&"
export * from "./request-number.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702ff83c",
  null
  
)

export default component.exports